import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { ME } from '../graphql/auth';
import DashboardSidebar from '../components/dashboard/DashboardSidebar';
import TableroTareas from '../components/dashboard/TableroTareas';
import EstadisticasRecientes from '../components/dashboard/EstadisticasRecientes';
import LlegadasSalidas from '../components/dashboard/LlegadasSalidas';
import HousekeepingPanel from '../components/dashboard/HousekeepingPanel';
import LimpiezaDashboard from '../components/dashboard/LimpiezaDashboard';
import Loading from '../components/shared/Loading';
import './Dashboard.css';

function Dashboard() {
  const [seccionActiva, setSeccionActiva] = useState('tareas');

  const { data: userData, loading: userLoading } = useQuery(ME);

  const user = userData?.me;
  const fechaOperativa = new Date().toLocaleDateString('es-CO', {
    day: '2-digit', month: '2-digit', year: 'numeric'
  });

  if (userLoading && !userData) return <Loading fullScreen />;

  // Personalized view for cleaning staff
  if (user?.rol === 'limpieza' || user?.rol === 'mantenimiento') {
    return <LimpiezaDashboard usuario={user} />;
  }

  return (
    <div className="dashboard-panel">
      <DashboardSidebar
        seccionActiva={seccionActiva}
        onCambiarSeccion={setSeccionActiva}
        fechaOperativa={fechaOperativa}
      />
      <div className="dashboard-panel__content">
        {seccionActiva === 'tareas' && <TableroTareas />}
        {seccionActiva === 'estadisticas' && <EstadisticasRecientes />}
        {seccionActiva === 'llegadas' && <LlegadasSalidas />}
        {seccionActiva === 'housekeeping' && <HousekeepingPanel />}
      </div>
    </div>
  );
}

export default Dashboard;
